;(function () {
  angular
    .module('contrast.cve')
    .controller('csCveInfoCtrl', [
      '$uibModal',
      'csCveInfoService',
      csCveInfoCtrl
    ])

  function csCveInfoCtrl($uibModal, csCveInfoService) {
    var vm = this
    vm.activate = activate

    var templateUrl = 'views/applications/settings/cve_modal.html'

    function activate() {
      csCveInfoService.init({
        vuln: vm.csCveInfo.data,
        type: vm.csCveInfo.type
      })
      launch()
    }

    function launch() {
      $uibModal.open({
        templateUrl: templateUrl,
        controller: 'csCveInfoModalCtrl',
        controllerAs: 'cveModalCtrl'
      })
    }
  }
}).call(this)
